module.exports = __webpack_public_path__ + "static/media/apple-store.59e04262.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Mealmanage/apple-store.png
// module id = 2414
// module chunks = 0